import store from '../store';
import systemRoutes from './module/system.js';  		    // 系统功能相关
import websiteProductRoutes from './module/website_product.js';  		// 网站管理【产品】
import websiteHomeRoutes from './module/website_home.js';  		    // 网站管理【首页】
import websiteKnowledgeRoutes from './module/website_knowledge.js'; // 网站管理【知识专区】
import websiteLaboratoryRoutes from './module/website_laboratory.js'; // 网站管理【实验室】
import websiteAboutRoutes from './module/website_about.js'; // 网站管理【实验室】
import websiteServiceRoutes from './module/website_service.js'; // 网站管理【服务】

export default [{
	path: '/login',
	name: 'login',
	component: () => import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: [
		{
			path: '',
			name: 'home',
			component: () => import('@/pages/home/index')
		},
		...systemRoutes,
		...websiteProductRoutes,
		...websiteHomeRoutes,
		...websiteKnowledgeRoutes,
		...websiteLaboratoryRoutes,
		...websiteAboutRoutes,
		...websiteServiceRoutes
	]
}, {
	path: '/decorate_manage/:type',
	name: 'decorate_manage',
	meta: {
		title: '装修系统'
	},
	props: route => Object.assign(route.query, route.params),
	component: () => import('@/submodule/decorate_manage/index')
}, {
	path: '/oss_manage',
	name: 'oss_manage',
	meta: {
		title: '图片空间'
	},
	component: () => import('@/submodule/oss_manage/index')
}, {
	path: '*',
	redirect: '/'
}];